//const gapi = window.gapi;
export default {
  userAccess: {}, //contient les informations renvoyés par google apres approbations.
  client_id:
    "513247959752-qapd9jb30pdtoh51m0h53070a2v8c4er.apps.googleusercontent.com",
};
